import script from "./RootPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RootPage.vue?vue&type=script&setup=true&lang=js"

import "./RootPage.vue?vue&type=style&index=0&id=001955d9&lang=css"

const __exports__ = script;

export default __exports__